/* Size chart popup (snippet rp-size-chart). Opens on the chart that matches the garment:
   - bundle shirt cards: <button class="rp-sc-open" data-sc-style="Women Polo">
   - split listings (option Fit): <button class="rp-sc-open" data-sc-type="Bowling Hoodie"> + the Fit picked in Dawn's picker,
     or data-sc-fit="Women's" when the bundle builder renders the Fit picker itself */
(function () {
  var dlg = document.getElementById('rp-sc');
  if (!dlg || dlg.dataset.ready) return;
  dlg.dataset.ready = '1';
  var tabs = [].slice.call(dlg.querySelectorAll('[role=tab]'));
  var note = dlg.querySelector('.rp-sc__note');
  var NO_WOMEN = "There is no separate women's chart for this style yet: the measurements shown are the unisex ones.";

  /* garment name (Style option value or product type + fit) -> chart key; women's quarter-zip / hoodie have no own chart */
  function resolve(name, women) {
    var s = String(name || '').toLowerCase();
    women = women || /women|ladies/.test(s);
    if (/hoodie/.test(s)) return { key: 'hoodie', note: women };
    if (/jersey/.test(s)) return { key: women ? 'womens-bowling-jersey' : 'bowling-jersey' };
    if (/zip/.test(s)) return { key: 'quarter-zip-polo', note: women };
    return { key: women ? 'women-polo' : 'unisex-polo' };
  }

  /* Fit chosen in Dawn's variant picker: radio pills (<variant-radios>) or dropdown (<variant-selects>), both named "Fit" */
  function pickedFit() {
    var el = document.querySelector('input[type=radio][name=Fit]:checked, select[name*=Fit], select[name*=fit]');
    return el ? el.value : '';
  }

  /* bring the tab into view sideways only (scrollIntoView would also scroll the dialog under its sticky bar);
     needs the dialog open, a closed <dialog> has no layout */
  function reveal(t) {
    var row = t.parentNode;
    if (t.offsetLeft < row.scrollLeft || t.offsetLeft + t.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollLeft = t.offsetLeft - 16;
  }

  function show(key, withNote) {
    tabs.forEach(function (t) {
      var on = t.dataset.scTab === key;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      p.hidden = !on;
      var img = p.querySelector('img[data-src]');
      if (on && img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
      if (on && dlg.open) reveal(t);
    });
    note.hidden = !withNote;
    note.textContent = withNote ? NO_WOMEN : '';
  }

  function open(btn) {
    /* data-sc-fit: the bundle builder's own Fit picker on single listings (Dawn's picker is hidden there) */
    var fit = btn.dataset.scFit != null ? btn.dataset.scFit : pickedFit();
    var r = btn.dataset.scType ? resolve(btn.dataset.scType, /women|ladies|female/i.test(fit)) : resolve(btn.dataset.scStyle);
    show(r.key, !!r.note);
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    dlg.scrollTop = 0;
    var sel = dlg.querySelector('[role=tab][aria-selected=true]');
    if (sel) { reveal(sel); sel.focus({ preventScroll: true }); }
  }

  function close() { if (dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); } }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.rp-sc-open');
    if (b) { e.preventDefault(); open(b); }
  });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-sc-close]')) return close();
    var t = e.target.closest('[role=tab]');
    if (t) show(t.dataset.scTab, false);
  });
  dlg.addEventListener('keydown', function (e) {
    var i = tabs.indexOf(document.activeElement);
    if (i < 0 || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    show(n.dataset.scTab, false);
    n.focus();
    e.preventDefault();
  });
})();
